module.exports = __webpack_public_path__ + "static/media/curly-hair.0d5598ea.png";